import { useEffect } from "react"
import { router } from "expo-router"
import { updatePlace } from "@/stores/analysisDataStore"
import Search from "@/screens/Search"
import {
  analysisSubmitted,
  analyzePropertySearchViewed,
} from "@/analytics/events/analyzer"
import { BFScreen } from "@/components/standard/screen/BFScreen"

export default function AnalyzeSearch() {
  useEffect(() => {
    analyzePropertySearchViewed()
  }, [])

  const onSelectPlace = (
    placeId: string | null,
    street: string,
    fullAddress: string
  ) => {
    if (placeId) {
      analysisSubmitted({ propertyAddress: fullAddress })
      updatePlace({ placeId, street, fullAddress })
      router.push(`/analyze/search/${placeId}`)
    }
  }

  return (
    <BFScreen dark={true} gradientBackground={true} noBackButton={true}>
      <Search title="Analyze" onSelectPlace={onSelectPlace} />
    </BFScreen>
  )
}
